import React from "react"
import { FormattedMessage } from "react-intl"
import { addAttrsInGeneral, addAttrsLogos, addCertificates, addManufacturingCertifications } from "../utils/sustainabilityActions"
import { constructEpdInformation, determineIfShowAlternativePolymer } from "../utils"

export const separeDataByGroups = ({
  sustainability, 
  manufacturingCertifications, 
  packagingFsc, 
  general, 
  epds, 
  locale
}) => {
  const compositionData = determineIfShowAlternativePolymer(general)
  const epd = constructEpdInformation(epds)
  
  // Composing structured data
  const structuredData = { 
    ...sustainability,
    ...compositionData,
    ...epd
  }

  const SUSTAINABILITY_GROUPS = [
    { id: 1, key: "attributes", defaultMessage: "Attributes" },
    { id: 2, key: "certifications", defaultMessage: "Certificates", areCertificates: true },
    { id: 3, key: "seals", defaultMessage: "Seals we contribute to", areCertificates: true },
    { id: 4, key: "manufacturing", defaultMessage: "Sustainable manufacturing certifications", areCertificates: true },
    { id: 5, key: "manufacturingProduction", defaultMessage: "Manufacturing certifications", areCertificates: true },
    { id: 6, key: "compliances", defaultMessage: "Compliances", areCertificates: true },
    { id: 7, key: "packaging", defaultMessage: "Packaging", areCertificates: true },
  ].map(group => ({
    ...group,
    title: (
      <FormattedMessage
        key={group.key}
        id={`FiltersBar.${group.key}FilterTitle`}
        description={`Title for ${group.key} filter section at filters bar`}
        defaultMessage={group.defaultMessage}
      />
    ),
    attrs: [],
  }));

  Object.entries(structuredData).forEach(([key, value]) => {
    addAttrsInGeneral(SUSTAINABILITY_GROUPS, packagingFsc, key, value)
    addAttrsLogos(SUSTAINABILITY_GROUPS, key, value, locale)
    addCertificates(SUSTAINABILITY_GROUPS, key, value)
  });

  addManufacturingCertifications(SUSTAINABILITY_GROUPS, manufacturingCertifications);

  const filteredGroups = SUSTAINABILITY_GROUPS.filter(group =>
    group.attrs.length > 0
  );
  return filteredGroups
}